import CommonModal from "../CommonModal";
import Assets from "../../Layouts/Assets";
import Style from "./ImageUploadModal.module.scss";
import { FixedSizeList } from "react-window";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Thumb from "./Thumb";
import Icons from "../../Layouts/Icons";
import { useSelector } from "react-redux";

const ImageUploadModal = ({
  fileInputRef,
  showModal,
  setShowModal,
  handleDrop,
  handleDragOut,
  handleDragOver,
  handleImageChange,
  uploadReadyImages,
  uploadResponses,
  currentlyUploading,
  fileUploadState,
}) => {
  const ListItem = ({ data, index, style }) => {
    return (
      <div
        className={`${Style.file_upload_preview_wrap} file_upload_preview_wrap`}
        style={style}
      >
        <Thumb image={data[index]} />
      </div>
    );
  };
  let validImages2 = uploadResponses?.total - uploadReadyImages?.length;

  const thumData =
    currentlyUploading &&
    validImages2 > uploadResponses?.uploaded &&
    uploadResponses?.total !== 0
      ? uploadReadyImages?.length > 0 && uploadResponses?.uploaded < 2
        ? [
            currentlyUploading,
            ...uploadResponses?.uploadedImage?.reverse()?.slice(-2),
            { duplicate: true, count: uploadReadyImages?.length },
          ]
        : [
            currentlyUploading,
            ...uploadResponses?.uploadedImage?.reverse()?.slice(-5),
          ]
      : uploadReadyImages?.length > 0
      ? [
          ...uploadResponses?.uploadedImage?.reverse()?.slice(-5),
          { duplicate: true, count: uploadReadyImages?.length },
        ]
      : [...uploadResponses?.uploadedImage?.reverse()?.slice(-5)];
  return (
    <CommonModal
      backdrop="static"
      keyboard={false}
      showModal={showModal}
      setShowModal={setShowModal}
      centered={true}
      className={Style.ImageUploadModal}
      content={
        <>
          {fileUploadState?.isUploading ? ( //uploading progress warning...
            <div className={Style.warningBox}>
              <img src={Assets?.upload_progress} alt="" />
              <h4>upload in Progress!</h4>
              <span>
                uploading is progress, Please wait until the process is
                complete.
              </span>
            </div>
          ) : (
            <div
              className={Style.ImageUploadModal__uploadBox}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onDragLeave={handleDragOut}
            >
              <label htmlFor="uploadImg">
                <figure>
                  <img src={Assets.blank_data_placeholder} alt="" />
                </figure>
                <span>
                  Drag and drop an image, <span>or Browse</span>
                </span>

                <input
                  ref={fileInputRef}
                  onChange={handleImageChange}
                  type="file"
                  className="d-none"
                  name="uploadImg"
                  accept="image/gif, image/jpeg, image/png"
                  id="uploadImg"
                  multiple
                />
              </label>
            </div>
          )}
          {!fileUploadState?.isUploading && (
            <div className={Style.file_upload_preview}>
              <div className={`${Style.file_upload_status} me-3 ms-0`}>
                <div
                  className={`${Style.add_more_btn_contents}  ${
                    uploadResponses?.uploaded >
                    uploadResponses?.total - uploadReadyImages?.length
                      ? uploadResponses?.total - uploadReadyImages?.length
                      : uploadResponses?.uploaded !==
                          uploadResponses?.total - uploadReadyImages?.length &&
                        "inprogress"
                  } `}
                >
                  <strong className="mb-sm-1">File Upload</strong>

                  <span>
                    {uploadResponses?.uploaded >
                    uploadResponses?.total - uploadReadyImages?.length
                      ? uploadResponses?.total - uploadReadyImages?.length
                      : uploadResponses?.uploaded}
                    /{uploadResponses?.total - uploadReadyImages?.length}
                  </span>
                  <OverlayTrigger
                    key={"bottom"}
                    placement={"bottom"}
                    variant="danger"
                    overlay={
                      <Tooltip
                        id={`tooltip-bottom`}
                        className={Style.tooltip_bottom}
                      >
                        <span>
                          Total - <strong>{uploadResponses?.total}</strong>
                        </span>
                        <span>
                          Uploaded -{" "}
                          <strong>{uploadResponses?.uploaded}</strong>
                        </span>
                        <span>
                          Duplicate -{" "}
                          <strong>
                            {
                              uploadReadyImages?.filter(
                                (item) => item.duplicate
                              )?.length
                            }
                          </strong>
                        </span>
                        <span>
                          Invalid -{" "}
                          <strong>
                            {
                              uploadReadyImages?.filter((item) => item.invalid)
                                ?.length
                            }
                          </strong>
                        </span>
                      </Tooltip>
                    }
                  >
                    <button
                      className={`btn btn-link border px-2 ${Style.upload_image_info_btn}`}
                    >
                      !
                    </button>
                  </OverlayTrigger>
                </div>
              </div>

              <div className={Style.file_upload_list_wrap_inneritem}>
                <FixedSizeList
                  itemData={thumData}
                  height={70}
                  itemCount={thumData?.length}
                  itemSize={124}
                  width={400}
                  direction="horizontal"
                  style={{ flex: "1 0", width: "100%" }}
                  className={Style.file_upload_list_wrap}
                >
                  {ListItem}
                </FixedSizeList>
              </div>

              <label className={Style.add_more_btn} for="uploadImg">
                <Icons size={18} icon={"icon-plus"} />
                <br />
                <span>Add more</span>
              </label>
            </div>
          )}

          {uploadResponses?.total - uploadReadyImages?.length ==
            uploadResponses?.uploaded &&
            uploadResponses?.uploaded !== 0 && (
              <span className={Style.sucessMsg}>
                Image uploaded Successfully.
              </span>
            )}
        </>
      }
    />
  );
};
export default ImageUploadModal;
